var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('b-loading',{attrs:{"is-full-page":_vm.isFull,"active":_vm.isActive,"can-cancel":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }